<template>
    <div>
        <div class="filter-bar">
            <el-form :inline="true" @submit.native.prevent="submitSearch">
                <el-form-item :label="filter.label+'：'" v-for="filter in filterOptions" v-if="filter.checked||filter.defaultVisible" :key="filter.name" class="custom-filter">
                    <BatchMultipleSelect
                        v-if="isBatchQueryField(filter)"
                        :ref="'batch'+filter.name+'Select'"
                        :value="tempQuery[filter.name]"
                        :options="filter.options"
                        :loading="filter.loading"
                        :remote-method="(query)=>remoteOptionsList(query,filter)"
                        @change="(val)=>changeOptionsSearch(val,filter)"
                        @batch-submit="(con)=>batchQuerySubmit(con,filter)"
                        @clear-all="(val)=>clearBatchSearch(val,filter)"
                        @change-all="(val)=>changeBatchSearchAll(val,filter)"
                        @show-options="showSelectOptions(filter)"
                        :title="filter.label"
                        :batch-desc="'输入或粘贴'+filter.label+'，每行一个'"
                        :clearable="true"
                        :collapse-tags="true"
                        :placeholder="getPlaceholder(filter)" />

                    <el-input v-else-if="filter.type=='content'" v-model="tempQuery[filter.name]" @keyup.enter.native="submitSearch" clearable placeholder="请输入" style="width: 200px;"></el-input>

<!--                    <el-select v-else-if="filter.type=='remote-select'"-->
<!--                               v-model="tempQuery[filter.name]"-->
<!--                               remote-->
<!--                               :remote-method="(query)=>remoteFilter(query,filter)"-->
<!--                               :loading="filter.loading"-->
<!--                               :multiple="!!filter.isMultiple"-->
<!--                               reserve-keyword-->
<!--                               collapse-tags-->
<!--                               filterable clearable-->
<!--                               :placeholder="filter.placeholder||'请选择'"-->
<!--                               style="width: 190px;">-->
<!--                        <el-option :label="option.name" :value="option.value" v-for="option in filter.options" :key="option.value"></el-option>-->
<!--                    </el-select>-->

<!--                    <el-select v-else-if="filter.type=='select'"-->
<!--                               v-model="tempQuery[filter.name]"-->
<!--                               :multiple="!!filter.isMultiple"-->
<!--                               collapse-tags-->
<!--                               filterable-->
<!--                               :clearable="!(apiType=='plan'&&filter.name=='plat_id')"-->
<!--                               :placeholder="filter.placeholder||'请选择'"-->
<!--                               :style="{width:filter.name=='yy_group_id'?'170px':'165px'}">-->
<!--                        <el-option :label="option.name" :value="option.id" v-for="option in filter.options" :key="option.id"></el-option>-->
<!--                    </el-select>-->
                    <SelectAll
                        v-else-if="filter.type=='select'&&filter.isMultiple"
                        :options="filter.options"
                        v-model="tempQuery[filter.name]"
                        :multiple="!!filter.isMultiple"
                        :clearable="!(apiType=='plan'&&filter.name=='plat_id')"
                        :placeholder="filter.placeholder||'请选择'"
                        :style="{width:filter.name=='yy_group_id'?'170px':'165px'}"
                    />
                    <ESelect v-else-if="filter.type=='select'&&!filter.isMultiple"
                               v-model="tempQuery[filter.name]"
                               filterable
                               :clearable="!(apiType=='plan'&&filter.name=='plat_id')"
                               :placeholder="filter.placeholder||'请选择'"
                               :style="{width:filter.name=='yy_group_id'?'170px':'165px'}">
                        <el-option :label="option.name" :value="option.id" v-for="option in filter.options" :key="option.id"></el-option>
                    </ESelect>
                    <el-date-picker
                        v-else-if="filter.type=='range_time'"
                        v-model="tempQuery[filter.name]"
                        style="width: 220px"
                        type="daterange"
                        align="center"
                        unlink-panels
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd"
                        range-separator="~"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>

                    <div v-if="!filter.defaultVisible" class="remove-btn pointer text-color-error" @click="removeFilter(filter)" title="删除">
                        <span class="relative" style="top:-2px;">x</span>
                    </div>
                </el-form-item>
                <el-form-item label="" label-width="0">
                    <el-button size="mini" type="primary" @click="showFilterConfigModal" plain>+添加</el-button>
                    <el-button size="mini" type="primary" :loading="dataLoading" @click="submitSearch" style="width: 75px;" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '筛选' }">筛选</el-button>
                    <el-button size="mini" @click="resetForm" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '重置筛选' }">重置筛选</el-button>
                </el-form-item>

            </el-form>
        </div>

        <div class="data-list pr10">
            <div class="tool-bar mb10">
                <el-button v-if="apiType=='plat'&&pageFuncNames.includes('add')" @click="addPlatModal" size="mini" type="primary" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '添加媒体' }"> + 添加媒体</el-button>
                <el-button v-if="apiType!='plat'&&pageFuncNames.includes('edit')" @click="handleBatchEdit" :disabled="rowSelected.length<=0" size="mini" type="primary" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '批量编辑' }" plain>批量编辑</el-button>
                <el-button v-if="pageFuncNames.includes('export')" size="mini" :loading="exportLoading" @click="exportData" style="width:75px;" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '导出' }">导出</el-button>
                <el-button size="mini" @click="showCustomFieldModal" class="custom-btn" title="自定义字段" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '自定义列' }">
                    <span class="ver-middle icon iconfont icon-jt-liebiaoshezhi-2" ></span>
                </el-button>
            </div>
            <div>
                <jt-table
                    :key="curKey"
                    :data="dataList"
                    stripe
                    v-loading="dataLoading||columnLoading"
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    :default-sort = "{prop: 'log_time', order: 'descending'}"
                    @selection-change="rowSelectionChange"
                    :cell-class-name="cellClassName"
                    style="width: 100%">
                    <el-table-column
                        v-if="apiType!='plat'"
                        fixed
                        type="selection"
                        align="center"
                        width="60">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        prop="action"
                        label="操作"
                        align="center"
                        width="120">
                        <template slot-scope="scope">
                            <div class="text-color-primary">
                                <span title="编辑" v-if="pageFuncNames.includes('edit')" class="action-btn pointer icon iconfont icon-jt-bianji" @click="showEditModal(scope.row)" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '列表(编辑)' }"></span>
                                <span title="详情" v-if="apiType == 'subproject'" class="action-btn pointer icon iconfont icon-jt-shujuchakan-05" style="margin-left: 8px;" @click="handleViewTable(scope.row)" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '列表(详情)' }"></span>
                                <span v-if="!pageFuncNames.includes('edit') && !(apiType == 'subproject')">-</span>
                            </div>
                        </template>
                    </el-table-column>


                    <el-table-column
                        v-for="(field,index) in columns"
                        :key="field.name+'-'+index"
                        :prop="field.name"
                        :label="field.label"
                        :fixed="index==0?'left':null"
                        :min-width="160"
                    >
                        <template slot="header" slot-scope="scope">
                            <span v-if="!field.title">{{field.label}}</span>
                            <el-tooltip v-else effect="dark" :content="field.title" placement="top">
                                <span class="pointer">{{field.label}} <i class="el-icon-question"></i></span>
                                <div slot="content" style="max-width: 300px;line-height: 20px;">{{field.title}}</div>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            <span v-if="field.name=='plat_id'&&apiType!='plat'">
                                <HoverEllipsisTips :text="scope.row.plat_name||'-'"/>
                            </span>
                            <template v-else-if="apiType=='plat'&&field.name=='docking_status'">
                                <span :class="scope.row[field.name]=='已对接'?'text-color-success':''">{{scope.row[field.name]||'-'}}</span>
                            </template>
                            <template v-else-if="apiType=='plat'&&field.name=='status'">
                                <span :class="scope.row[field.name]=='停用'?'text-color-error':''">{{scope.row[field.name]||'-'}}</span>
                            </template>
                            <span v-else-if="field.source=='user'">
                                <HoverEllipsisTips :text="scope.row[field.name+'_name']||'-'"/>
                            </span>
                            <template v-else-if="field.source=='user_system'">
                                <el-tooltip
                                    v-if="scope.row[field.name+'_system']&&scope.row[field.name+'_user']&&scope.row[field.name+'_user']!=scope.row[field.name+'_system']"
                                    effect="dark" :content="'系统判定：'+scope.row[field.name+'_system_name']" placement="top-start">
                                    <span  class="text-color-error">{{scope.row[field.name+'_name']||'--'}}</span>
                                </el-tooltip>
                                <span v-else>{{scope.row[field.name+'_name']||'--'}}</span>
                            </template>
                            <template v-else-if="apiType == 'subproject' && field.name=='account'">
                                <HoverEllipsisTips :text="scope.row[field.name]" :toHtml="'account'"/>
                            </template>
                            <template v-else-if="apiType == 'subproject' && field.name=='company_name'">
                                <HoverEllipsisTips :text="scope.row['company_name_uq'].join('；')" :toHtml="'account'"/>
                            </template>
                            <template v-else-if="apiType == 'subproject' && field.name=='bloc_name'">
                                <HoverEllipsisTips :text="scope.row['bloc_name_uq'].join('；')" :toHtml="'account'"/>
                            </template>

                            <template v-else-if="field.name=='subproject'">
                                <div>
                                    <el-tooltip placement="top" popper-class="el-tooltip-max-height-set">
                                        <div slot="content" style="max-height: 50vh;overflow-y: auto;">
                                            <div>
                                                <div v-for="(item, index) in scope.row['children']" :key="index">
                                                    <p>{{item.plat_name}} ({{(item.children||[]).length}})</p>
                                                    <p v-for="(child, index_child) in item['children']" :key="index_child" style="padding-left: 10px;white-space: nowrap;">
                                                        {{child.subproject_name || '-'}} ({{child.subproject_id || '-'}}) ({{child.subproject_content || '-'}})
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <span :style="{cursor: 'pointer', color:'#409eff'}">{{scope.row['subproject']}}</span>
                                    </el-tooltip>
                                </div>
                            </template>
                            <span  v-else-if="field.name=='account_status'" :style="{color: (scope.row[field.name] != '审核通过' && scope.row[field.name] != '未知') ? '#ff0000' : '#606266'}">
                                {{scope.row[field.name]||'-'}}
                            </span>
                            <template v-else>
                                <HoverEllipsisTips :text="scope.row[field.name]||'-'"/>
                            </template>
                        </template>
                    </el-table-column>
                </jt-table>
            </div>

        </div>
        <div class="page-bar tac mt20" v-show="!dataLoading">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryData.pn"
                :page-sizes="[30,50,100]"
                :page-size="queryData.rn"
                :pager-count="5"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCnt">
            </el-pagination>
        </div>

        <FilterConfigModal ref="filterConfigModal" :api-type-name="apiTypeName" :list="filterOptions" @save="updateFilter"/>
        <CustomFieldModal ref="customFieldModal" :api-type-name="apiTypeName" :config="filterOptions" :field-type="apiType+'_tag'" :select-list="userFields" @save="updateFields" />
        <SingleEditModal ref="singleEditModal" :api-type-name="apiTypeName" :data="actionRow" :form-list="editableFields" :tab-type="apiType" @update="getDataList"/>
        <BatchEditModal ref="batchEditModal" :api-type-name="apiTypeName" :data-list="rowSelected" :form-list="editableFields" :tab-type="apiType" @update="getDataList"/>
    </div>
</template>

<script>
    import CustomFieldModal from '../modal/customFieldModal';
    import FilterConfigModal from '../modal/filterConfigModal';
    import SingleEditModal from '../modal/singleEditModal';
    import BatchEditModal from '../modal/batchEditModal';
    import BatchMultipleSelect from '@/components/BatchMultipleSelect';
    import API from '@/api/baseInfo/tag.js';
    import SelectAll from '@/components/SelectAll';
    import {previewTableModal,addPlatModal} from '../modal/index.js'
    import {cloneDeep, throttle, merge} from "lodash";
    import HoverEllipsisTips from "../components/hoverEllipsis.vue";
    import matomoFun from "@/utils/matomo.js";
    import { ESelect } from '@/components/Ele/eSelect';

    export default {
        name: "ListPage",
        props:["pageFuncNames","pageFields","apiType"],
        components:{
            HoverEllipsisTips,
            SelectAll,
            FilterConfigModal,
            CustomFieldModal,
            SingleEditModal,
            BatchEditModal,
            BatchMultipleSelect,
            ESelect,
        },
        data(){
            return {
                dataLoading:true,
                exportLoading:false,
                columnLoading:false,
                queryData:{
                    pn: 1,
                    rn: 30,
                },
                tempQuery:{},
                dataList:[],
                totalCnt:0,
                rowSelected:[],
                columns:[],
                filterOptions:[],
                fieldConfig:[],     // 自定义字段-所有
                userFields:[],      // 用户保存的自定义字段
                actionRow:{},
                curKey: 0, //处理 表格提示宽度计算错误问题
                include_list: ['account_name', 'account_id', 'app_status', 'account_status'],
                fetchDisable: false,  //禁止多次请求
                pickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time){
                        return time.getTime() > Date.now();
                    },
                },
            }
        },
        computed:{
            // tableMaxHeight(){
            //     return document.body.clientHeight - 75 - 55;
            // },
            editableFields(){
                return this.filterOptions.filter(item=>item.editable===true||item.editable == 'true').map(item=>{
                    return {
                        type:item.type,
                        label:item.label,
                        name:item.name,
                        options:[],
                        source:item.source,
                        allOptions:[],
                    }
                });
            },
            apiTypeName(){
                if(this.apiType == 'plat') return '媒体';
                if(this.apiType == 'bloc') return '集团';
                if(this.apiType == 'company') return '客户';
                if(this.apiType == 'platusername') return '代理';
                if(this.apiType == 'account') return '账户';
                if(this.apiType == 'plan') return '计划';
                if(this.apiType == 'app'||this.apiType == 'subproject') return '产品';
                if(this.apiType == 'project') return '项目';
                return '';
            },
        },
        created(){
        },
        mounted(){
//             subproject_id[0]
// 525453
// subproject_name[0]
// 指尖捕鱼-爆金版
        },
        watch:{
            pageFields: {
                handler(new_value) {
                    let pageFields = new_value||[];
                    if(pageFields.length<=0) return this.dataLoading = false;
                    const query = this.$route.query;
                    console.log(query, 'queryquery');
                    this.filterOptions = pageFields.map(item=>{
                        let configStr = item.config||"{}";
                        let config = JSON.parse(configStr);
                        let isSelect = config.type=='select'||config.type=='search_multiple_select';
                        let type = config.type=='content'?'content':(isSelect?'select':config.type||'');
                        const data = {
                            label:item.display_name,
                            name:item.name,
                            type:type,
                            title:config.title,
                            editable:config.editable,
                            defaultVisible:config.default_visible=='true',
                            checked:false,
                            options:[],
                            isMultiple:config.type=='search_multiple_select',
                            placeholder:'',
                            source:config.source,
                            loading:false,
                            allOptions:[],
                        };
                       
                        // subproject_name subproject_name
                       
                        return data;
                    });
                   
                    this.filterOptions.forEach(item=>{
                        if(item.type=='content'){
                            if(this.apiType=='plan'&&(item.name=='plan_name'||item.name=='plan_id'||item.name=='app_package')){
                                this.$set(this.tempQuery,item.name,[]);
                            }else if(this.apiType=='subproject'&&(item.name=='subproject_name'||item.name=='subproject_id'||item.name=='subproject_content')) {
                                this.$set(this.tempQuery,item.name,[]);
                            }else if(this.apiType=='project'&&item.name=='project_name'||item.name=='subproject') {
                                this.$set(this.tempQuery,item.name,[]);
                            }else{
                                this.$set(this.tempQuery,item.name,'');
                            }

                        }else if(item.type == 'select'){
                            API.getSearchList({
                                apiType:this.apiType,
                                api_type:this.apiType,
                                search_type:item.name,
                                search_for:'filter',
                            }).then(res=>{
                                let resData = res.data||{};
                                let list = resData.list||[];
                                 if(query[item.name]){
                                    if(this.isBatchQueryField(item)) {
                                        list.push( { value: query[item.name], label: query[item.name] })
                                        this.$set(this.tempQuery,item.name, [query[item.name]]);
                                    }
                                };
                                this.$set(item,'options',list||[]);
                                if(this.apiType=='plan'){
                                    if(item.name=='plat_id'&&list.length>0){
                                        this.$set(this.tempQuery,'plat_id',list[0].id);
                                        this.submitSearch();
                                    }
                                }
                            });

                            if(item.isMultiple){
                                if(item.name=='subproject_id'){
                                    let routeParams = this.$route.params;
                                    let list = [];
                                    if(routeParams){
                                        list = (routeParams.list||[]).map(item=>item.id);
                                        item.options = [...routeParams.list||[]];
                                        this.$set(this.queryData,item.name,list);
                                    }
                                    this.$set(this.tempQuery,item.name,list);
                                }else{
                                    this.$set(this.tempQuery,item.name,[]);
                                }
                            }else{
                                this.$set(this.tempQuery,item.name,'');
                            }
                        }else{
                            this.$set(this.tempQuery,item.name,null);
                        }

                    })
                },
                deep: true,
                immediate: true
            }
        },
        beforeDestroy(){
            window.removeEventListener("resize", this.calcTableHeight);
        },
        methods:{
            getPlaceholder(params) {
                //"plan_id" 计划id  "app_package" 投放产品  "account_id" 账号id  "subproject_id" 推广id "subproject_content" 推广内容
                if(this.apiType=='plat'&&params.name=='plat_id') return '请输入媒体ID';
                let arr = ["plan_id", "app_package", "account_id", "subproject_id", 'subproject_content']
                if(arr.includes(params.name)) {
                    return '请输入关键字搜索'
                }else{
                    return '请输入名称关键字搜索'
                }
            },
            isBatchQueryField(field){
                if(this.apiType=='plan'&&(field.name=='plan_name'||field.name=='plan_id'||field.name=='account_id'||field.name=='app_package')) return true;
                if(this.apiType=='subproject'&&(field.name=='subproject_name'||field.name=='subproject_id'||field.name=='subproject_content')) return true;
                if(this.apiType=='project'&&(field.name=='project_name' || field.name=='subproject')) return true;
                if(this.apiType=='plat'&&(field.name=='plat_id' || field.name=='plat_name'||field.name=='creator'||field.name=='latest_modifier')) return true;
                return false;
            },
            async initPageStates(){
                this.columnLoading = true

                await this.getCustomFilter();
                await this.getCustomField();
                if(this.apiType!='plan'){
                    let routeParams = this.$route.params;
                    let routeQuery = this.$route.query;
                    if(routeParams){
                        let list = (routeParams.list||[]).map(item=>item.id);
                        this.$set(this.queryData,'subproject_id',list);
                    }
                    if(routeQuery&&this.apiType=='subproject'){
                        this.dataLoading = true;
                        this.tempQuery.plat_id = routeQuery?.plat_id ? [routeQuery.plat_id] : [];
                        let filter = this.filterOptions.find(item=>item.name=='subproject_id');
                        if(filter){
                            let isArray = Array.isArray(routeQuery.subproject_id);
                            await this.batchQuerySubmit(isArray?routeQuery.subproject_id:[routeQuery.subproject_id],filter);
                        }
                    }
                    this.submitSearch();
                }
            },
            calcTableHeight(){

            },
            async getCustomFilter(){
                await API.getCustomFilter({
                    field_type:this.apiType+'_tag_filter',
                }).then(res => {
                    let resData = res.data || [];
                    this.filterOptions.forEach(item=>{
                        this.$set(item,'checked',resData.map(item=>item.name).includes(item.name));
                    });
                }, (err) => {
                    console.log('getCustomFilter error', err);
                });
            },
            showFilterConfigModal(){
                this.$refs.filterConfigModal.showModal();
            },
            updateFilter(list){
                console.log('updateFilter',list);
                this.filterOptions.forEach(item=>{
                    if(list.includes(item.name)){
                        item.checked = true;
                    }else{
                        item.checked = false;
                        this.tempQuery[item.name] = [];
                    }
                });
                API.setCustomFilter({
                    field_type:this.apiType+'_tag_filter',
                    fields:list.map(item=>{
                        let actionItem = this.filterOptions.find(inner=>inner.name==item)||{};
                        return {
                            name:item,
                            label:actionItem.label,
                        }
                    }),
                });
            },
            removeFilter(filter){
                this.tempQuery[filter.name] = [];
                let actionFilter = this.filterOptions.find(item=>item.name==filter.name);
                if(actionFilter){
                    actionFilter.checked = false;
                }
                API.setCustomFilter({
                    field_type:this.apiType+"_tag_filter",
                    fields:this.filterOptions.filter(item=>item.checked).map(item=>{
                        return {
                            name:item.name,
                            label:item.label,
                        }
                    }),
                });
            },
            resetForm(){
                this.filterOptions.forEach(item=>{
                    if(this.apiType=='plan'&&item.name=='plat_id'){
                        // 计划tab页，投放媒体不可清空，重置时跳过
                    }else{
                        if(item.type=='content'||(item.type == 'select'&&!item.isMultiple)){
                            this.tempQuery[item.name] = '';
                        }else if(item.type == 'select'&&item.isMultiple){
                            this.tempQuery[item.name] = [];
                        }
                    }
                });
                this.submitSearch();
            },
            async getCustomField(){
                await API.getCustomField({
                    field_type:this.apiType+'_tag',
                }).then(res => {
                    let resData = res.data || [];
                    this.userFields = resData||[];
                    this.$nextTick(()=>{
                        this.makeColumns();
                    })
                },err=>{
                    console.log('getCustomField err',err);
                    this.userFields = [];
                });
            },
            makeColumns(){
                this.columnLoading = true;
                let deep_list = cloneDeep(this.userFields)
                // 产品的时候 特殊处理
                // if(this.apiType == 'subproject') {
                //     let find_index = deep_list.findIndex(item=>item.name === 'account')
                //     let cache_list = this.filterOptions.filter(item=>this.include_list.includes(item.name)).map(item=>{
                //         return {
                //             name:item.name,
                //             label:item.label,
                //         }
                //     });
                //     deep_list.splice(find_index,1, ...cache_list)
                // }

                this.columns = deep_list.map(item=>{
                    if(this.apiType == 'subproject' && item.name == 'account') {
                        item.title= '账户数量：账户名称+账户ID+账户状态+投放状态'
                        return item
                    }else{
                        let colItem = this.filterOptions.find(field=>field.name==item.name)||{};
                        return colItem;
                    }

                });
                this.columnLoading = false;

                // this.columns = this.userFields.map(item=>{
                //     let colItem = this.filterOptions.find(field=>field.name==item.name)||{};
                //     return colItem;
                // });
                // this.columnLoading = false;
            },
            updateFields(list){
                console.log('updateFields',list);
                this.userFields = (list||[]).map(item=>item);
                this.getDataList();
                this.makeColumns();
            },
            // submitSearch(){
            //     this.queryData.pn = 1;
            //     this.filterOptions.forEach(item=>{
            //         this.queryData[item.name] = this.tempQuery[item.name];
            //     });
            //     this.getDataList();
            // },
            submitSearch:throttle(function (){
                this.queryData.pn = 1;
                this.filterOptions.forEach(item=>{
                    this.queryData[item.name] = this.tempQuery[item.name];
                });
                this.getDataList();
            }, 2000),
            getDataList(){
                if(this.fetchDisable) {
                    return
                }
                this.fetchDisable = true

                this.dataLoading = true;
                let reqData = {
                    apiType:this.apiType,
                };
                for(let item in this.queryData){
                    if(item=='range_time'||item=='latest_modification_time'){
                        reqData[item] = this.queryData[item]?.join(' / ');
                    }else{
                        reqData[item] = this.queryData[item];
                    }
                }


                this.dataList = []
                API.getDataList(reqData).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;

                    this.$nextTick(()=>{
                        this.dataList = resData.list.map(item=>{
                            let account_id_length = item.account_id ? item.account_id.length : 0;
                            let account_name_length = item.account_name ? item.account_name.length : 0;
                            let account_status_length = item.account_status ? item.account_status.length : 0;
                            let app_status_length = item.app_status ? item.app_status.length : 0;
                            let company_name_length = item.company_name ? item.company_name.length : 0;
                            let bloc_name_length = item.bloc_name ? item.bloc_name.length : 0;
                            let max_length = Math.max(account_id_length,account_name_length,account_status_length,app_status_length, company_name_length, bloc_name_length)
                            item['expand_length'] = max_length > 0 ? max_length : 0;
                            return {...item}
                        });
                    })
                    this.totalCnt = resData.totalCnt;

                    // let account_id_length =
                    this.curKey++
                }, (err) => {
                    console.log('getDataList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                }).finally(()=>{
                    this.fetchDisable = false
                });
            },
            handleBatchEdit(){
                this.$refs.batchEditModal.showModal();
                console.log('handleBatchEdit');
            },
            exportData(){
                console.log('exportData');
                this.exportLoading = true;
                let reqData = {
                    apiType:this.apiType,
                };
                for(let item in this.queryData){
                    reqData[item] = this.queryData[item];
                }

                API.exportList(reqData).then(res => {
                    this.exportLoading = false;
                    this.$message.success(res.info||'操作成功');

                }, (err) => {
                    console.log('exportData error', err);
                    this.exportLoading = false;
                    let errData = err.data||[];
                    if(err.code==0&&errData.length>0){
                        this.$notify.error({
                            title: err.info||'请求失败',
                            message: errData.join('；'),
                            duration: 0
                        });
                    }else{
                        this.$message.error(err.info||'操作失败');
                    }
                });
            },
            showCustomFieldModal(){
                this.$refs.customFieldModal.showModal();
            },
            rowSelectionChange(val){
                this.rowSelected = val.map(item => item);
            },
            showEditModal(row){
                console.log('showEditModal',row);
                if(this.apiType=='plat'){
                    const {vm} = addPlatModal({
                        props: {
                            data:{...row},
                            title:'编辑',
                            editableFields:this.editableFields,
                        },
                        cbs: {
                            onSubmit: () => {
                                this.getDataList();
                            }
                        },
                        on:{
                            close:()=>{
                                matomoFun.trackEvent('标签管理(媒体)', '点击', '编辑媒体(取消)');
                                vm.close();
                            }
                        }
                    })
                }else{
                    this.actionRow = row;
                    this.$refs.singleEditModal.showModal();
                }
            },
            handleSizeChange(val) {
                this.queryData.rn= val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList();
            },
            remoteOptionsList(query,filter){
                if (query !== '') {
                    filter.loading = true;
                    let batchApi = '';
                    if(this.apiType=='plan'){
                        if(filter.name=="app_package") {
                            batchApi = 'postAppPackageSearchList'
                        }else{
                            batchApi = 'remotePlanOptionsList';
                        }
                    }else if(this.apiType=='subproject'){
                        batchApi = 'remoteSubProjectOptionsList';
                    }else if(this.apiType=='project'){
                        if(filter.name=="subproject") {
                            batchApi = 'postSubprojectSearchList'
                        }else{
                            batchApi = 'remoteProjectOptionsList';
                        }
                    }else if (this.apiType=='plat'){
                        batchApi = 'remotePlatOptionsList';
                    }else{
                        return;
                    }

                    API[batchApi]({
                        search_type:filter.name,
                        search:query,
                    }).then(res=>{
                        filter.loading = false;
                        let resData = res.data||{};
                        let dataItem = resData[filter.name]||{};
                        filter.options = (dataItem.list||[]).map(item=>{
                            return {
                                value:item.id,
                                label:item.name,
                            }
                        });

                        filter.options.forEach(item=>{
                            if(!filter.allOptions.find(inner=>inner.label==item.label&&inner.value==item.value)){
                                filter.allOptions.push({...item});
                            }
                        })
                    },err=>{
                        filter.loading = false;
                        console.log('getBlocOptionList err',err);
                        filter.options = [];
                    })
                } else {
                    filter.options = [];
                }

            },
            changeOptionsSearch(val,filter){
                this.tempQuery[filter.name] = [...val];
            },
            async batchQuerySubmit(con,filter){
                /*此处拿到的数组形式，所以取[0] */
                let $batchSelect = this.$refs['batch'+filter.name+'Select'][0];

                let batchApi = '';
                // if(this.apiType=='plan'){
                //     batchApi = 'remotePlanOptionsList';
                // }else if(this.apiType=='subproject'){
                //     batchApi = 'remoteSubProjectOptionsList';
                // }else if(this.apiType=='project'){
                //     batchApi = 'remoteProjectOptionsList';
                // }else{
                //     return;
                // }
                if(this.apiType=='plan'){
                    if(filter.name=="app_package") {
                        batchApi = 'postAppPackageSearchList'
                    }else{
                        batchApi = 'remotePlanOptionsList';
                    }
                }else if(this.apiType=='subproject'){
                    batchApi = 'remoteSubProjectOptionsList';
                }else if(this.apiType=='project'){
                    if(filter.name=="subproject") {
                        batchApi = 'postSubprojectSearchList'
                    }else{
                        batchApi = 'remoteProjectOptionsList';
                    }
                }else if (this.apiType=='plat'){
                    batchApi = 'remotePlatOptionsList';
                }else{
                    return;
                }

                await API[batchApi]({
                    search_type:filter.name,
                    batch_search:con,
                }).then(res=>{

                    $batchSelect.hideBatchLoading();

                    let resData = res.data || {};
                    let dataItem = resData[filter.name]||{};
                    let successList = dataItem.list||[];
                    let errList = dataItem.err_list||[];

                    if(errList.length>0){
                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        htmlStr += '<p>未找到以下内容，请核实，是否需要剔除未找到的内容?</p>';
                        htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                        this.$confirm(htmlStr, '提示', {
                            confirmButtonText: '剔除',
                            cancelButtonText: '关闭',
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            customClass:'batch-err-tips-modal',
                            width:'500',
                        }).then(()=>{
                            this.addBatchSuccessList(successList,filter);
                            $batchSelect.hideBatchModal();
                        });
                    }else{
                        this.addBatchSuccessList(successList,filter);
                        $batchSelect.hideBatchModal();
                    }
                },err=>{
                    console.log('batchQuerySubmit batch error', err);
                    $batchSelect.hideBatchLoading();
                    this.$message.error(err.info||'请求有误');
                })
            },
            addBatchSuccessList(list,filter){
                console.log('addBatchSuccessList',list,filter);
                let checkedIdList = filter.options.map(item=>item.value);
                (list||[]).forEach(item=>{
                    if(!checkedIdList.includes(item.id)){
                        filter.options.push({
                            value:item.id,
                            label:item.name,
                        });

                        if(!filter.allOptions.find(inner=>inner.value==item.value&&inner.label==item.label)){
                            filter.allOptions.push({
                                value:item.id,
                                label:item.name,
                            });
                        }
                    }
                    if(!this.tempQuery[filter.name].includes(item.id)){
                        this.tempQuery[filter.name].push(item.id);
                    }
                })
            },
            clearBatchSearch(val=[],filter){
                console.log('clearBatchSearch',val,filter);
                val.forEach(item=>{
                    let index = this.tempQuery[filter.name].findIndex(inner=>inner==item);
                    if(index!=-1){
                        this.tempQuery[filter.name].splice(index,1);
                    }
                })

            },
            changeBatchSearchAll(val,filter){
                console.log('changeBatchSearchAll',val,filter);
                let oldVal = this.tempQuery[filter.name];
                let newVal = [...val].filter(item=>!oldVal.includes(item));
                this.$set(this.tempQuery,filter.name,oldVal.concat(newVal));
            },
            showSelectOptions(filter){
                let value = this.tempQuery[filter.name]||[];
                filter.options = value.map(item=>{
                    let actionItem = filter.allOptions.find(inner=>inner.value==item);
                    return {
                        name:actionItem?actionItem.label : item,
                        value:item,
                    }
                })
            },
            // 2.16.1.0.0 标签管理显示上级对应信息 全选与取消 n

            // 表格列class添加
            cellClassName({row, column, rowIndex, columnIndex}) {
                if(column.property == 'account_id' || column.property == 'account_name' || column.property == 'account_status' || column.property == 'app_status') {
                    return 'cell_vertical-align-top'
                }
            },
            handleViewTable(rows) {
                let title = rows ? `预览 ${rows.plat_name}-${rows.subproject_name}` : '预览'
                const {vm} = previewTableModal(
                    {
                        props: {
                            list: [rows],
                            columns: this.filterOptions,
                            title:title
                        },
                        cbs: {
                            onSubmit: (data) => {

                            }
                        },
                        on:{
                            close:()=>{
                                matomoFun.trackEvent('标签管理(产品)', '点击', '列表(详情-关闭)');
                                vm.close();
                            }
                        }
                    }
                )
            },
            addPlatModal(){
                console.log('addPlatModal');
                const {vm} = addPlatModal({
                    props: {
                        data:{},
                        title:'添加媒体',
                        editableFields:this.editableFields,
                    },
                    cbs: {
                        onSubmit: () => {
                            this.getDataList();
                        }
                    },
                    on:{
                        close:()=>{
                            matomoFun.trackEvent('标签管理(媒体)', '点击', '添加媒体(取消)');
                            vm.close();
                        }
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .filter-bar{
        background-color: #f8f8f9;
        padding: 20px 20px 0;
        border-radius: 5px;
        margin-bottom: 20px;
        ::v-deep .custom-filter .el-input{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            .el-input__inner{
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }

        .remove-btn{
            display: inline-block;
            background-color: #FFF;
            border: 1px solid #DCDFE6;
            border-left: none;
            width: 20px;
            text-align: center;
            border-radius: 0 4px 4px 0;
            position: relative;
            z-index: 1;
            height: 32px;
            line-height: 32px;
            top: 2px;
        }

        ::v-deep .custom-filter .el-select__tags-text{
            max-width: 50px;
        }
    }
    .tool-bar{
        display: flex;
    }
    .tool-bar .custom-btn{
        padding: 5px;
        vertical-align: -2px;
    }
    .expand_table_border{
        margin-left: -10px;
        margin-right: -10px;
        .borderBottom{
            border-bottom: 1px solid #EBEEF5;
            padding-top: 8px;
            padding-bottom: 8px;
            padding-left: 10px;
            min-height: 40px;
            &:last-child{
                border-bottom: none;
            }
        }
    }
    .data-list{
        ::v-deep.cell_vertical-align-top.el-table__cell{
            vertical-align: top;
        }
    }
</style>
<style lang="scss">
.el-tooltip-max-height-set{
    &.el-tooltip__popper[role="tooltip"]{
        max-width: 1000px !important;
    }
}
</style>
